import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Recategorize an email from the detail panel: the ⋮ menu's "Label" row shows
// the current triage category and opens the list as a second level of the same
// menu (`panel` gets is-picking); picking a new category PATCHes a manual
// correction (which also teaches future triage for the same sender).
export default class extends Controller {
    static targets = ["label", "option", "panel"]
    static values = { url: String }

    // Second level in place rather than a flyout: the menu opens at the
    // window's right edge, where a side flyout has nowhere to go.
    pick(event) {
        event.preventDefault()
        if (this.hasPanelTarget) this.panelTarget.classList.add("is-picking")
    }

    // Back row, and every open/close of the menu, returns to the first level.
    back() {
        if (this.hasPanelTarget) this.panelTarget.classList.remove("is-picking")
    }

    async choose(event) {
        event.preventDefault()
        let category = event.currentTarget.dataset.category
        if (!category) return

        let previous = this.hasLabelTarget ? this.labelTarget.textContent : null
        if (this.hasLabelTarget) this.labelTarget.textContent = event.currentTarget.dataset.label || category

        try {
            let response = await fetch(this.urlValue, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
                },
                body: JSON.stringify({ category: category })
            })
            let data = await response.json().catch(() => ({}))
            if (!response.ok) throw new Error(data.error || "Could not recategorize")
            if (this.hasLabelTarget && data.label) this.labelTarget.textContent = data.label
            this._markActive(category)
            showSystemToast("Category updated - Jane remembers this for this sender.")
        } catch (error) {
            if (this.hasLabelTarget && previous !== null) this.labelTarget.textContent = previous
            showSystemToast(error.message || "Could not recategorize", { level: "danger" })
        }
    }

    _markActive(category) {
        this.optionTargets.forEach((option) => {
            option.classList.toggle("is-active", option.dataset.category === category)
            option.setAttribute("aria-pressed", String(option.dataset.category === category))
        })
    }
}
